// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
import { isNamedKeyCredential, isSASCredential, isTokenCredential, } from "@azure/core-auth";
export function isCredential(credential) {
    return (isSASCredential(credential) || isNamedKeyCredential(credential) || isTokenCredential(credential));
}
